import {
  colors,
  font,
  radius,
  spacing,
} from '@coverflex-tech/hypernova-design-tokens';
import { CnOptions, createTV, cn as tvCn } from 'tailwind-variants';
import { flatShadows } from './shadows';

const twMergeConfig = {
  extend: {
    theme: {
      borderRadius: Object.keys(radius.mobile),
      padding: [...Object.keys(spacing.mobile), 'safe'],
      margin: Object.keys(spacing.mobile),
      gap: Object.keys(spacing.mobile),
      spacing: Object.keys(spacing.mobile),
    },
    classGroups: {
      shadow: [{ shadow: Object.keys(flatShadows) }],
      'font-size': [{ text: Object.keys(font.mobile) }],
      'font-family': [{ font: ['F37', 'F37Bold'] }],
      'text-color': [{ color: Object.keys(colors.light.semantic.text) }],
      'bg-color': [{ bg: Object.keys(colors.light.semantic.surface) }],
      'border-color': [{ border: Object.keys(colors.light.semantic.border) }],
    },
  },
};

export const tv = createTV({
  twMergeConfig,
});

export const cn = (...classes: CnOptions) =>
  tvCn(...classes)({ twMergeConfig });
